import { defineMessages } from 'react-intl';

export default defineMessages({
  'title_from_date' : {
    'id' : 'admin.title.from_date',
    'defaultMessage' : 'From date'
  },
  'title_to_date' : {
    'id' : 'admin.title.to_date',
    'defaultMessage' : 'To date'
  },
  'today' : {
    'id' : 'admin.dropdown.today',
    'defaultMessage' : 'Today'
  },
  'yesterday' : {
    'id' : 'admin.dropdown.yesterday',
    'defaultMessage' : 'Yesterday'
  },
  'two_days_ago' : {
    'id' : 'admin.dropdown.two_days_ago',
    'defaultMessage' : '2 days ago'
  },
  'three_days_ago' : {
    'id' : 'admin.dropdown.three_days_ago',
    'defaultMessage' : '3 days ago'
  },
  'four_days_ago' : {
    'id' : 'admin.dropdown.four_days_ago',
    'defaultMessage' : '4 days ago'
  },
  'five_days_ago' : {
    'id' : 'admin.dropdown.five_days_ago',
    'defaultMessage' : '5 days ago'
  },
  'six_days_ago' : {
    'id' : 'admin.dropdown.six_days_ago',
    'defaultMessage' : '6 days ago'
  },
  'seven_days_ago' : {
    'id' : 'admin.dropdown.seven_days_ago',
    'defaultMessage' : '7 days ago'
  },
  'today_day_last_year' : {
    'id' : 'admin.dropdown.today_day_last_year',
    'defaultMessage' : 'Today day last year'
  },
  'this_week' : {
    'id' : 'admin.dropdown.this_week',
    'defaultMessage' : 'This week'
  },
  'last_week' : {
    'id' : 'admin.dropdown.last_week',
    'defaultMessage' : 'Last Week'
  },
  'two_weeks_ago' : {
    'id' : 'admin.dropdown.two_weeks_ago',
    'defaultMessage' : '2 weeks ago'
  },
  'three_weeks_ago' : {
    'id' : 'admin.dropdown.three_weeks_ago',
    'defaultMessage' : '3 weeks ago'
  },
  'four_weeks_ago' : {
    'id' : 'admin.dropdown.four_weeks_ago',
    'defaultMessage' : '4 weeks ago'
  },
  'this_week_number_last_year' : {
    'id' : 'admin.dropdown.this_week_number_last_year',
    'defaultMessage' : 'This week number last year'
  },
  'this_month' : {
    'id' : 'admin.dropdown.this_month',
    'defaultMessage' : 'This month'
  },
  'last_month' : {
    'id' : 'admin.dropdown.last_month',
    'defaultMessage' : 'Last month'
  },
  'two_months_ago' : {
    'id' : 'admin.dropdown.two_months_ago',
    'defaultMessage' : '2 months ago'
  },
  'three_months_ago' : {
    'id' : 'admin.dropdown.three_months_ago',
    'defaultMessage' : '3 months ago'
  },
  'this_month_last_year' : {
    'id' : 'admin.dropdown.this_month_last_year',
    'defaultMessage' : 'This month last year'
  },
  'this_quarter' : {
    'id' : 'admin.dropdown.this_quarter',
    'defaultMessage' : 'This Quarter'
  },
  'last_quarter' : {
    'id' : 'admin.dropdown.last_quarter',
    'defaultMessage' : 'Last quarter'
  },
  'two_quarters_ago' : {
    'id' : 'admin.dropdown.two_quarters_ago',
    'defaultMessage' : '2 quarters ago'
  },
  'three_quarters_ago' : {
    'id' : 'admin.dropdown.three_quarters_ago',
    'defaultMessage' : '3 quarters ago'
  },
  'four_quarters_ago' : {
    'id' : 'admin.dropdown.four_quarters_ago',
    'defaultMessage' : '4 quarters ago'
  },
  'this_half_year' : {
    'id' : 'admin.dropdown.this_half_year',
    'defaultMessage' : 'This half-year'
  },
  'last_half_year' : {
    'id' : 'admin.dropdown.last_half_year',
    'defaultMessage' : 'Last half-year'
  },
  'this_year' : {
    'id' : 'admin.dropdown.this_year',
    'defaultMessage' : 'This year'
  },
  'last_year' : {
    'id' : 'admin.dropdown.last_year',
    'defaultMessage' : 'Last year'
  },
  'select_one' : {
    'id' : 'admin.dropdown.select_one',
    'defaultMessage' : 'Select one'
  },
  'custom_date' : {
    'id' : 'admin.dropdown.custom_date',
    'defaultMessage' : 'Custom'
  },
  'no_results' : {
    'id' : 'admin.dropdown.no_results',
    'defaultMessage' : 'No results found'
  },
  'previous_month': {
    'id' : 'admin.dropdown.previous_month',
    'defaultMessage': 'Previous month',
  },
  'previous_day': {
    'id' : 'admin.dropdown.previous_day',
    'defaultMessage': 'Previous day',
  },
  'previous_week': {
    'id' : 'admin.dropdown.previous_week',
    'defaultMessage': 'Previous week',
  },
  'previous_quarter': {
    'id' : 'admin.dropdown.previous_quarter',
    'defaultMessage': 'Previous quarter',
  },
  'previous_year': {
    'id' : 'admin.dropdown.previous_year',
    'defaultMessage': 'Previous year',
  },
  'previous_half_year': {
    'id' : 'admin.dropdown.previous_half_year',
    'defaultMessage': 'Previous half-year',
  },
  'up_to_now': {
    'id': 'up_to_now',
    'defaultMessage': 'up to now',
  },
  'to_date': {
    'id': 'to_date',
    'defaultMessage': 'to date',
  },
  'today_last_year': {
    'id': 'today_last_year',
    'defaultMessage': 'Today last year',
  },
});